import HttpService from './HttpService'

const _http = new HttpService()
export default {
  show: (page, options = null) => {
    let _parans = `?page=${page - 1}`;
    if (options) {
      if(options.search) {
        _parans += `&search=${options.search}`;
      }
      if (options.orderByKey) {
        _parans += `&order_by=${options.orderByKey}`
      }
      if (options.ascOrDes) {
        _parans += '&asc'
      }
    }
    return _http.get(`/api/operators${_parans}`)
  },
  find: (id) => {
    return _http.get(`/api/operators/${id}`)
  },
  create: (payload) => {
    return _http.post('/api/operators', payload)
  },
  update: (payload) => {
    return _http.put('/api/operators', payload)
  },
  delete: (id) => {
    return _http.delete(`/api/operators/${id}`)
  },
  showOperatorsAll: () => {
    return _http.get(`/api/operators/operators-all`)
  },
  showOperatorsWithUser: () => {
    return _http.get(`/api/operators/operators-with-user`)
  },
}